import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

const AboutPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.location.href = 'https://peersight.carrd.co/';
    }, []);

    return (
        <div>
            <h1 className="greeting">
                Přesměrovávám vás!
            </h1>
        </div>
    );
};

export default AboutPage;